import { FieldDesc } from '90.quickConnect.Models/models';

const mapToFieldVisibility = (field: FieldDesc): boolean => field.isVisible; // isVisible -> présent dans la déclaration

export default mapToFieldVisibility;
